export const configTab = {
  selectTypeList: [
    // { 'keys': "BREAKINGNEWS", 'value': "BreakingNews" },
    { 'keys': "PRODUCTS", 'value': "Products" },
    { 'keys': "COUPONS", 'value': "Coupons" },
    { 'keys': "ROLES", 'value': "Roles" },
    { 'keys': "STATUS", 'value': "Status" },
  ],
  title: 'Configuration',
  addConfig: "Add Configuration",

  productsAddSuccess: 'Product added successfully',
  productsAddFailed: 'Failed to add product',
  productsUpdateSuccess: 'Product updated successfully',
  productsUpdateFailed: 'Failed to update product',

  deleteSucess: "Product deleted successfully",
  deleteFailed: "Failed to delete product",
  deleteConfirm: 'Are you sure you want to delete this product?',
  deleteHead: 'Confirm Delete',
  deleteOk: 'Delete',
  deleteCancel: 'Cancel',

  edit: "Edit",
  delete: "Delete",

  noDataFound: "No products found",
  noData: "No Data Found",

  marketsAddSuccess: 'Market added successfully',
  marketsAddFailed: 'Failed to add market',
  marketsUpdateSuccess: 'Market updated successfully',
  marketsUpdateFailed: 'Failed to update market',

  deleteMarketSucess: "Market deleted successfully",
  deleteMarketFailed: "Failed to delete market",
  deleteMarketConfirm: 'Are you sure you want to delete this market?',

  displayedColumnsProducts: [
    "productName",
    "sku",
    "productPrice",
    "productDesc1",
    "buttons"
  ],

  displayedKeyColumns: [
    {
      name: 'Name',
      value: 'productName'
    },
    {
      name: 'Sku',
      value: 'sku'
    },
    {
      name: 'Price',
      value: 'productPrice'
    },
    {
      name: 'Description',
      value: 'productDesc1'
    }
  ],

  success: "success",
  failed: "failed",

  productName: "Name",
  productPrice: "Price",
  productDesc1: "Description",
  sku: "Sku",

  productNameReq: "Name is required",
  productPriceReq: "Price is required",
  productDesc1Req: "Description is required",
  skuReq: "Sku is required",

  add: "Add",
  editProductsTitle: "Edit Product",
  editMarketsTitle: "Edit Market",

  marketName: "Name",
  marketNameReq: "Name is required",
  noDataMarket: "No markets found",

  firmName: "Name",
  firmNameReq: "Name is required",
  noDataFirm: "No firms found",
  market: "Market",
  marketReq: "Market is required",

  officeName: "Name",
  officeNameReq: "Name is required",
  noDataOffice: "No offices found",
  firm: "Firm",
  firmReq: "Firm is required",

  firmsAddSuccess: 'Firm added successfully',
  firmsAddFailed: 'Failed to add firm',
  firmsUpdateSuccess: 'Firm updated successfully',
  firmsUpdateFailed: 'Failed to update firm',

  deleteFirmSucess: "Firm deleted successfully",
  deleteFirmFailed: "Failed to delete firm",
  deleteFirmConfirm: 'Are you sure you want to delete this firm?',

  officesAddSuccess: 'Office added successfully',
  officesAddFailed: 'Failed to add office',
  officesUpdateSuccess: 'Office updated successfully',
  officesUpdateFailed: 'Failed to update office',

  linkFirmFailed: "Failed to link firm to office",
  linkOfficeFailed: "Failed to link office to firm",

  configureSuccess: "Successfully configured",

  deleteOfficeSucess: "Office deleted successfully",
  deleteOfficeFailed: "Failed to delete office",
  deleteOfficeConfirm: 'Are you sure you want to delete this office?',

  editOfficeTitle: "Edit Office",
  editFirmTitle: "Edit Firm",
  firms: "Firms",
  firmsReq: "Firms is required",
  offices: "Offices",
  officesReq: "Offices is required",

  couponCode: "Coupon Code",
  couponDesc: "Coupon Description",
  couponAmount: "Coupon Amount",
  totalLimit: "Total Limit",
  expireDate: "expireDate",
  couponCodeReq: "Coupon Code is required",
  couponDescReq: "Coupon Description is required",
  couponAmountReq: "Coupon Amount is required",
  totalLimitReq: "Total Limit is required",
  couponsAddSuccess: 'Coupon added successfully',
  couponsAddFailed: 'Failed to add coupon',
  couponsUpdateSuccess: 'Coupon updated successfully',
  couponsUpdateFailed: 'Failed to update coupon',

  deleteCouponSucess: "Coupon deleted successfully",
  deleteCouponFailed: "Failed to delete coupon",
  deleteCouponConfirm: 'Are you sure you want to delete this coupon?',

  invalidType: "Invalid type",

  editCouponTitle: "Edit Coupon",
  noCouponFound: "No coupon found",
  displayedColumnsCoupons: [
    "couponCode",
    "couponDesc",
    "couponAmount",
    "totalLimit",
    "usageLimit",
    "remainingCoupon",
    "expireDate",
    "buttons"
  ],
  displayedCouponKeyColumns: [
    {
      name: 'Coupon Code',
      value: 'couponCode'
    },
    {
      name: 'Coupon Description',
      value: 'couponDesc'
    },
    {
      name: 'Coupon Amount',
      value: 'couponAmount'
    },
    {
      name: 'Total Coupons',
      value: 'totalLimit'
    },
    {
      name: 'Used Coupons',
      value: 'usageLimit'
    },
    {
      name: 'Remaining Coupons',
      value: 'remainingCoupon'
    },
    {
      name: 'Expire Date',
      value: 'expireDate'
    },
  ],
  rolesAddSuccess: 'Role added Successfully',
  rolesAddFailed: 'Failed to add role',
  rolesUpdateSuccess: 'Role updated successfully',
  rolesUpdateFailed: 'Failed to update role',

  deleteRoleSucess: "Role deleted successfully",
  deleteRoleFailed: "Failed to delete role",
  deleteRoleConfirm: 'Are you sure you want to delete this role?',

  editRoleTitle: "Edit Role",
  roleName: "Role Name",
  roleDescription: "Role Description",
  roleDescriptionReq: "Role Name is required",
  roleNameReq: "Role Description is required",

  statusAddSuccess: 'Status added successfully',
  statusAddFailed: 'Failed to add status',
  statusUpdateSuccess: 'Status updated successfully',
  statusUpdateFailed: 'Failed to update status',

  deletestatusucess: "Status deleted successfully",
  deletestatusFailed: "Failed to delete status",
  deletestatusConfirm: 'Are you sure you want to delete this status?',

  editstatusTitle: "Edit status",
  statusReq: "status is required",

  statusName: "Name",
  statusNameReq: "Name is required",

  displayStatusName: "Name",
  displayStatusReq: "Name is required",
  marketCompanyAffiliateBtn: "Market/ Company/ Affiliate Database",
  addOrUpdatemarketCompanyAffiliateBtn: "Save",
  sheetTitle: "Market/ Company/ Affiliate Database",
  showAllFirms: "Show all firms",
  showAllOffices: "Show all offices",
  marketType: "market",
  firmType: "firm",
  officeType: "office",
  addNew: "Add New",
  editExtOffice: "Edit Existing Office",
  editExtFirm: "Edit Existing Firm",
  editExtMarket: "Edit Existing Market",
  noMailTypes: "No mail types found",
  mailTypeName: "Name",
  mailTypeNameReq: "Name is required",
  mailTypeAddSuccess: 'Mail Type added successfully',
  mailTypeAddFailed: 'Failed to mail type',
  mailTypeUpdateSuccess: 'Mail Type updated successfully',
  mailTypeUpdateFailed: 'Failed to update mail type',

  deleteEmailTypeSucess: "Mail type deleted successfully",
  deleteEmailTypeFailed: "Failed to delete mail type",
  deleteEmailTypeConfirm: 'Are you sure you want to delete this mail type?',
  noMailTypeContent: "No mail type content found",
  emailType: "Email Type",
  emailContent: "Email Content",
  mailTypeContentAddSuccess: 'Mail Type content added successfully',
  mailTypeContentAddFailed: 'Failed to mail type content',
  emailContentReq: "Email Content is required",
  emailTypeNameReq: "Email Type is required",
  deleteEmailTypeContentSucess: "Mail type content deleted successfully",
  deleteEmailTypeContentFailed: "Failed to delete mail type content",
  deleteEmailTypeContentConfirm: 'Are you sure you want to delete this mail type content?',
  editMailTypeContentTitle: "Edit mail type content",
  mailTypeContentUpdateSuccess: 'Mail Type content updated successfully',
  mailTypeContentUpdateFailed: 'Failed to update mail type content',
  breakingNews: 'Breaking News',
  breakingNewsReq: 'Breaking News is required',
  breakingNewsAddSuccess: 'Breaking News added successfully',
  breakingNewsAddFailed: 'Failed to breaking news',
  breakingNewsUpdateSuccess: 'Breaking News updated successfully',
  breakingNewsUpdateFailed: 'Failed to update breaking news',

  deleteBreakingNewsSucess: "Breaking News deleted successfully",
  deleteBreakingNewsFailed: "Failed to delete breaking news",
  deleteBreakingNewsConfirm: 'Are you sure you want to delete this breaking news?',
  noBreakingNewsContent: "No breaking news data found",
  displayedColumnsNews: [
    "newsMessage",
    "edit",
    "isActive",
    "delete"
  ],

  displayedNewsKeyColumns: [
    {
      name: 'Breaking News',
      value: 'newsMessage'
    },
    {
      name: 'Edit',
      value: 'edit'
    },
    {
      name: 'Is Active',
      value: 'isActive'
    },
    {
      name: 'Delete',
      value: 'delete'
    }
  ],
  editBreakingNewsTitle: "Edit Breaking News",
  isActive: "Is Active",
  chooseLogo:"Choose Logo"
}

export const marketsReports = {
  title: "Markets Reports",
  sheetTitle: "Market/ Company/ Affiliate Reports",
  keyIndicator: "Key Performance Indicators:",
  market: "Market: ",
  quoteMtd: "# of Quotes MTD: ",
  approveRepair: "# of approved repairs: ",
  repairConvesrion: "Repair Conversion: ",
  
  displayedColumnsMarkertReport: [
    "marketName",
    "firmName",
    "officesName",
    "totalCountQuotes",
    "totalReapairQuotes"
  ],

  displayedKeyColumnss: [
    {
      name: 'Market',
      value: 'marketName'
    },
    {
      name: 'Company',
      value: 'firmName'
    },
    {
      name: 'Office',
      value: 'officesName'
    },
    {
      name: '# of quotes received from this office year to date',
      value: 'totalCountQuotes'
    },
    {
      name: '# of repair request received from this office year to date',
      value: 'totalReapairQuotes'
    }
  ],

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/configuration.ts